import { useQuery } from '@tanstack/react-query';
import ApiConstants from '../../constants/ApiConstants';
import xhr from '../../utils/api/xhr';

export interface LessonWithIssue {
  id: string;
  started_at: string;
  ended_at: string;
  status: string;
  issue_type: string;
  issue_reported_at: string;
  tutor?: {
    id: string;
    name: string;
    avatar_url?: string;
  };
  student?: {
    id: string;
    name: string;
    avatar_url?: string;
  };
}

interface LessonsWithIssueResponse {
  lessons: LessonWithIssue[];
  numOfLessons: number;
}

export const lessonsWithIssueKeys = {
  all: ['lessonsWithIssue'] as const,
  student: (page: number) => [...lessonsWithIssueKeys.all, 'student', page] as const,
  tutor: (page: number) => [...lessonsWithIssueKeys.all, 'tutor', page] as const,
};

async function fetchStudentLessonsWithIssue(page: number): Promise<LessonsWithIssueResponse> {
  const query = `?page=${page}`;
  return xhr(`${ApiConstants.FetchStudentLessonsWithOpenIssue}${query}`);
}

async function fetchTutorLessonsWithIssue(page: number): Promise<LessonsWithIssueResponse> {
  const query = `?page=${page}`;
  return xhr(`${ApiConstants.FetchTutorLessonsWithOpenIssue}${query}`);
}

export function useStudentLessonsWithIssueQuery(page = 1) {
  return useQuery({
    queryKey: lessonsWithIssueKeys.student(page),
    queryFn: () => fetchStudentLessonsWithIssue(page),
  });
}

export function useTutorLessonsWithIssueQuery(page = 1) {
  return useQuery({
    queryKey: lessonsWithIssueKeys.tutor(page),
    queryFn: () => fetchTutorLessonsWithIssue(page),
  });
}
